/* eslint-disable react/no-multi-comp */
import React, { useState, useEffect, useRef } from "react"
import Img from "gatsby-image/withIEPolyfill"
import cookie from "react-cookies"

import { CONSTANTS, CONTENT } from "@data"
import { Headline, HubSpotForm } from "@shared"
import Styles from "./emailModal.module.scss"

const { SUBSCRIBE } = CONTENT
const { error } = SUBSCRIBE

const { SUBMIT } = CONSTANTS

const EmailModal = props => {
  const { data } = props
  const { isModalEnabledOnSite } = data

  const [open, setOpen] = useState(false)
  const [holderListening, setHolderListening] = useState(false)
  const [stat] = useState(SUBMIT.IDLE)

  const modalHolderRef = useRef(null)

  const outsideClickListener = event => {
    if (event.target === modalHolderRef.current) {
      // eslint-disable-next-line no-use-before-define
      onClose()
    }
  }
  const onClose = () => {
    modalHolderRef.current.removeEventListener("click", outsideClickListener)
    setOpen(false)
  }
  // eslint-disable-next-line spaced-comment
  //    //

  useEffect(() => {
    const modalViewed = cookie.load("exo_email_modal_viewed")
    if (!modalViewed && isModalEnabledOnSite) {
      setTimeout(function() {
        setOpen(true)
      }, 5000)
    }
  }, [])

  useEffect(() => {
    if (open) {
      if (!holderListening) {
        setHolderListening(true)
        modalHolderRef.current.addEventListener("click", outsideClickListener)
      }

      cookie.save("exo_email_modal_viewed", true, {
        path: "/"
      })
    }
  }, [open])

  return (
    <div
      ref={modalHolderRef}
      className={`${Styles.modalHolder} ${open ? Styles.fadeIn : Styles.fadeOut}`}
    >
      <button
        type="button"
        className={Styles.closeButton}
        onClick={onClose}
        aria-expanded={open}
        // aria-controls={objs.demoContent}
        aria-label="Close Demo Form"
      >
        <span className={Styles.closeWrapper}>
          <span className={`${Styles.closeItem} ${Styles.closeOne}`} />
          <span className={`${Styles.closeItem} ${Styles.closeTwo}`} />
        </span>
      </button>
      <div className={`${Styles.modal}`}>
        <div className={`${Styles.modalChild}  ${Styles.first}`}>
          <div className={`${Styles.modalContent}`}>
            {data.heroImage.fluid ? (
              <Img
                style={{ position: "unset" }}
                className={Styles.imgItem}
                fluid={data.heroImage.fluid}
                alt={data.heroImage.title}
              />
            ) : null}
          </div>
        </div>
        <div className={`${Styles.modalChild} ${Styles.second}`}>
          <div className={`${Styles.modalContent}`}>
            <div className={`${Styles.modalCenterV}`}>
              <p className={Styles.body}>{stat === SUBMIT.FAIL ? error : null}</p>
              {/* <div className={Styles.hero}>
                {data.heroText}
              </div> */}
              <Headline size="3" className={Styles.hero}>
                <span>{data.heroText}</span>
              </Headline>
              <div className={Styles.support}>{data.supportingText}</div>
              <div className={Styles.form}>
                <HubSpotForm
                  id="email-modal-form-subscription"
                  portalId="20465501"
                  formId="ce86ff4b-80f7-4187-800b-de1c3c178b0b"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EmailModal
